module.exports = __webpack_public_path__ + "media/images/powerpoint/co-meet-background-2fd3b61d951edb0938e22dc8e877a1ca.png";